<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof44">
<p class="tit"><em class="italic">Ranks in the Russian Officer Corps, 1800-1826</em></p>
<p class="centerImage" id="tab6"><img alt="image" id="imgfr27" src="images/imgfr27.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof44.vue?da784666